import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AutocompletePromocodeCampaignsQuery } from "../graphql/queries";
import type {
  AutocompletePromocodeCampaignsQueryType,
  AutocompletePromocodeCampaignsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAutocompletePromocodeCampaignsQuery = (
  options?: QueryHookOptions<
    AutocompletePromocodeCampaignsQueryType,
    AutocompletePromocodeCampaignsQueryVariablesType
  >
) => {
  return useQuery<
    AutocompletePromocodeCampaignsQueryType,
    AutocompletePromocodeCampaignsQueryVariablesType
  >(AutocompletePromocodeCampaignsQuery, options);
};
